module.exports = __webpack_public_path__ + "img/14备份.770ca94b.jpg";